import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import SideBar from "@/components/sidebar";
import LoadingPage from "@/components/ui/LoadingPage";
import Overlay from "@/components/ui/overlay";
import { MapProvider } from "@/context/MapProvider";
import { useAuth } from "@/hooks/auth/useAuth";
import useAnalysisJob from "@/hooks/useAnalysisJob";
import { RootState } from "@/store";

const ProtectedRoute = () => {
  const { isAuthenticating, isAuthenticated } = useAuth();

  const { showComparisonPopup, isDrawPolygon, showLoadingOverlay } =
    useSelector((state: RootState) => state.ui);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Redirect to login only when not authenticating and user is not authenticated
    if (!isAuthenticating && !isAuthenticated) {
      navigate("/login", {
        replace: true,
        state: { from: `${location.pathname}${location.search}` }
      });
    }
  }, [
    navigate,
    location.pathname,
    location.search,
    isAuthenticated,
    isAuthenticating
  ]);

  useAnalysisJob();

  // check the !isAuthenticated to wait the navigation to login page
  if (isAuthenticating || !isAuthenticated) {
    return <LoadingPage />;
  }

  return (
    <MapProvider>
      <div className="flex h-screen text-[12px]">
        {showLoadingOverlay && <Overlay />}
        {!showComparisonPopup.isShow && !isDrawPolygon && <SideBar />}
        <div className="flex flex-grow flex-col overflow-hidden">
          <Outlet />
        </div>
      </div>
    </MapProvider>
  );
};

export default ProtectedRoute;
